//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'DetailMoreInfosection',
  props: {
    data: {
      type: Object,
      default: null
    },
    tetherData: {
      type: Object,
      default: null
    }
  }
}
